import { Client } from '@/utilities/api/Client';
import { IntegrationEndpoint } from '@api/endpoints';
import { QueryUtil } from "@/utilities/Query";

export class IntegrationApi {
  static createForRetailer (
    retailerId: string,
    body: IntegrationEndpoint.Create.Request,
  ): Promise<IntegrationEndpoint.Create.Response> {
    return Client(`retailers/${retailerId}/integration`, { body, method: 'POST' });
  }

  static getByRetailerId (retailerId: string): Promise<IntegrationEndpoint.Get.Response> {
    return Client(`retailers/${retailerId}/integration`);
  }

  static getSyncHistory (
    retailerId: string,
    query: IntegrationEndpoint.GetSyncHistory.Query,
  ): Promise<IntegrationEndpoint.GetSyncHistory.Response> {
    return Client(`retailers/${retailerId}/integration/sync-history?${QueryUtil.stringify(query)}`);
  }

  static getSyncStatus (retailerId: string): Promise<IntegrationEndpoint.GetSyncStatus.Response> {
    return Client(`retailers/${retailerId}/integration/sync-status`);
  }

  static sync (
    retailerId: string,
    body: IntegrationEndpoint.Sync.Request,
  ): Promise<void> {
    return Client(`retailers/${retailerId}/integration/sync`, { body, method: 'POST' });
  }
}
